<template>
  <v-timeline-item
    class="item"
    :color="item.fromHiL ? '#60A694' : '#FF7C5D'"
    small
  >
    <v-layout pt-3>
      <v-flex xs3>
        <strong>{{ item.date | date }}</strong>
      </v-flex>
      <v-flex>
        <strong>{{ title }}</strong>
        <div class="caption mb-2">
          <span v-for="(link, i) in links" :key="i" v-if="link != null"
            ><a :href="link.href">{{ link.label }}</a
            ><span v-if="i !== links.length - 1">,&nbsp;</span>
          </span>
        </div>
        <div class="caption mb-2" v-if="description != null">
          {{ description }}
        </div>
        <div class="caption mb-2">
          <a
            @click.prevent="$emit('delete', item)"
            href="#"
            style="color:red;"
            class="delete-line"
            >Supprimer la ligne</a
          >
        </div>
      </v-flex>
    </v-layout>
  </v-timeline-item>
</template>

<script>
export default {
  props: ["item", "titleGetter", "linkGetter", "descriptionGetter"],
  computed: {
    title() {
      return this.titleGetter(this.item);
    },
    links() {
      return this.linkGetter(this.item);
    },
    description() {
      return this.descriptionGetter(this.item);
    }
  }
};
</script>
<style scoped>
.item .delete-line {
  display: none;
}
.item:hover .delete-line {
  display: inline;
}
</style>
